import { render, staticRenderFns } from "./ChangedBuildingList.vue?vue&type=template&id=4259a3e5&scoped=true&"
import script from "./ChangedBuildingList.vue?vue&type=script&lang=js&"
export * from "./ChangedBuildingList.vue?vue&type=script&lang=js&"
import style0 from "./ChangedBuildingList.vue?vue&type=style&index=0&id=4259a3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259a3e5",
  null
  
)

export default component.exports